import { Injectable } from "@angular/core";
import { LocalStorageCachingStorageService } from "common";
import { BrokerFacade } from "../broker/domain/+state/broker.facade";
import { OAuthService } from "@partner/core/services/oauth.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(
    private oauthService: OAuthService,
    private brokerFacade: BrokerFacade,
    private cache: LocalStorageCachingStorageService,
  ) {}

  logout() {
    this.oauthService.sessionEndLocal();
    this.brokerFacade.clearBrokerCache();
    this.cache.clear();
  }
}
